// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  border: 1px solid #ccc;
  border-radius: 15px;
  background-color: white;
}
  .card__header {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
  }
  .card__header__left {
      display: flex;
      align-items: flex-end;
      font-size: 16px;
      font-weight: 400;
    }
  .card__header__right {
      display: flex;
      align-items: center;
      font-weight: 400;
    }
  .card__body {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding-left: 20px;
    padding-right: 20px;
  }
  .card__table-body {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  .card__divider {
    width: 100%;
    height: 1px;
    border-bottom: 1px solid gray;
  }
.card__title {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.card__title--large {
    font-size: 24px;
    font-weight: 400;
  }
.card__title--small {
    font-size: 20px;
    font-weight: 400;
  }

@media screen and (min-width: 1440px) {
  .card__title--small {
    font-size: 22px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Card.pcss"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AAuCzB;EAtCE;IACE,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;EAYf;EAXE;MACE,aAAa;MACb,qBAAqB;MACrB,eAAe;MACf,gBAAgB;IAClB;EACA;MACE,aAAa;MACb,mBAAmB;MACnB,gBAAgB;IAClB;EAEF;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;EACb;EACA;IACE,WAAW;IACX,WAAW;IACX,6BAA6B;EAC/B;AAEF;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAS7B;AARE;IACE,eAAe;IACf,gBAAgB;EAClB;AACA;IACE,eAAe;IACf,gBAAgB;EAClB;;AAGF;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["$midDesktop: 990px;\n$smallDesktop: 750px;\n.card {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  border: 1px solid #ccc;\n  border-radius: 15px;\n  background-color: white;\n  &__header {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px;\n    &__left {\n      display: flex;\n      align-items: flex-end;\n      font-size: 16px;\n      font-weight: 400;\n    }\n    &__right {\n      display: flex;\n      align-items: center;\n      font-weight: 400;\n    }\n  }\n  &__body {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n  &__table-body {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n  }\n  &__divider {\n    width: 100%;\n    height: 1px;\n    border-bottom: 1px solid gray;\n  }\n}\n.card__title {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  &--large {\n    font-size: 24px;\n    font-weight: 400;\n  }\n  &--small {\n    font-size: 20px;\n    font-weight: 400;\n  }\n}\n\n@media screen and (min-width: 1440px) {\n  .card__title--small {\n    font-size: 22px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
